import React, { useEffect } from 'react'
import {
  Route,
  Redirect
} from 'react-router-dom'
import Loader from 'components/Loader'
import { useDispatch, useSelector } from 'react-redux'
import PrivateRoutePage from 'components/PrivateRoutePage'
import CreateWorkspacePage from 'containers/CreateWorkspacePage'
import { setPrevPage } from 'utils/common/actions'



const PrivateRoute = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch()
  const workspacesIsLoading = useSelector(state => state.auth.workspacesIsLoading)
  const userInfoIsLoading = useSelector(state => state.auth.userInfoIsLoading)
  const workspaces = useSelector(state => state.auth.workspaces)

  useEffect(() => {
    return () => {
      dispatch(setPrevPage(rest.location.pathname + rest.location.search))
    }
  }, [rest.location]) // eslint-disable-line react-hooks/exhaustive-deps

  const renderPage = (props) => {
    if (!rest.authToken) {
      return <Redirect to='/login' />
    }
    if (rest.activeWorkspace) {
      if (rest.activeWorkspace.in_invitation && rest.path !== '/settings' && rest.path !== '/') {
        return <Redirect to='/' />
      }
      return (
        <PrivateRoutePage>
          <Component {...props} />
        </PrivateRoutePage>
      )
    } else if (workspacesIsLoading || userInfoIsLoading) {
      return <Loader />
    } else if (!workspaces || workspaces.length === 0) {
      return <CreateWorkspacePage {...props} />
    }
    return <Loader />
  }

  return <Route
    {...rest}
    render={props => renderPage(props)}
  />
}

export default PrivateRoute
